import React, { useState, useEffect } from "react";
import axios from 'axios';
function TaskReport() {
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("");
  const [search, setSearch] = useState("");
  const fetchAllTask = async () => {
    try {
      const res = await axios.get(`https://api.sweepydo.in/fetch-all-task`);
      setData(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllTask();
  }, []);

  // const filtered = data.filter((item) => {
  //   const searchValue = searchTerm.toLowerCase();

  //   const matchSearch = Object.values(item)
  //     .join(" ")
  //     .toLowerCase()
  //     .includes(searchValue);

  //   const matchPlan = selectedPlan
  //     ? item.sub_name === selectedPlan
  //     : true;

  //   return matchSearch && matchPlan;
  // });

  const filtered = data.filter(item => {
    const searchValue = searchTerm.toLowerCase();
    const matchSearch = Object.values(item).join(" ").toLowerCase().includes(searchValue);
    const matchPlan = selectedPlan ? item.sub_name === selectedPlan : true;
    const itemMonth = item.sub_history_rec_date.slice(0, 7);
    const matchFromDate = fromDate ? itemMonth >= fromDate : true;
    const matchToDate = toDate ? itemMonth <= toDate : true;
    return matchSearch && matchPlan && matchFromDate && matchToDate;
  });
  const formattedData = filtered.map(s => {
    const services = JSON.parse(s.sub_history_service_name);
    const service = services.find(item => item.sId === s.service_id);
    return {
      ...s,
      service_name: service ? service.name : "N/A"
    };
  });
  return <div className="container-fluid mt-1 p-4" style={{
    minHeight: "100vh"
  }}>


      <h2 className="text-center mb-4 text-white">Monthly Task Report </h2>

      <div style={{
      background: "var(--black)",
      borderRadius: "12px",
      padding: "15px"
    }}>
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 ">


          <div style={{
          minWidth: "250px"
        }}>
            <input type="text" className="form-control p-2 "
          // style={{ maxWidth: "300px" }}
          placeholder="Search plan..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} style={{
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }} />
          </div>



          <div className="d-flex align-items-center gap-3 flex-wrap">


            <input type="month" className="form-control" value={fromDate} onChange={e => setFromDate(e.target.value)} style={{
            width: "180px",
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }} />

            <input type="month" className="form-control" value={toDate} onChange={e => setToDate(e.target.value)} style={{
            width: "180px",
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }} />



          </div>



        </div>


        <div className='table-responsive '>
          <table style={{
          width: "100%",
          borderCollapse: "collapse",
          color: "#fff"
        }}>
            <thead>
              <tr style={{
              backgroundColor: "var(--black2)"
            }}>
                <th style={{
                padding: "18px",
                textAlign: "center"
              }}>SN</th>
                <th style={{
                padding: "18px",
                textAlign: "center"
              }}>User Name</th>
                <th style={{
                padding: "18px",
                textAlign: "center"
              }}>User Mobile</th>
                <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Staff Name</th>
                <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Staff Mobile</th>
                <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Service Name</th>
                <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Start Date</th>
                <th style={{
                padding: "18px",
                textAlign: "center"
              }}>End Date </th>

              </tr>
            </thead>
            {formattedData.map((s, i) => <tr key={s.id} style={{
            backgroundColor: "var(--black)",
            borderBottom: "1px solid rgba(255,255,255,0.06)",
            transition: "0.3s"
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = "var(--black2)";
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = "var(--black)";
          }}>
                <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{i + 1}</td>
                <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{s.users_name}</td>
                <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{s.users_mobile}</td>
                <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{s.staff_name}</td>
                <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{s.staff_mobile}</td>
                <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{s.service_name}</td>
                <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{s.sub_history_rec_date}</td>
                <td style={{
              padding: "18px",
              textAlign: "center"
            }}>{s.sub_history_end_date}</td>
              </tr>)}
          </table>
        </div>

      </div>
    </div>;
}
export default TaskReport;
